module.exports = __webpack_public_path__ + "img/afrin_nasal_spray.0e4031d6.png";